export default __webpack_public_path__ + "static/media/10.db944a7b.png";